<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'lms-hero',
    props: {
		imgSmall: {
		  type: String,
		},
		imgMedium: {
		  type: String,
		},
		imgLarge: {
		  type: String,
		},
    },
    data() {
      return {
		bgImg: null,
      }
    },
	watch: {
      $breakpoint() {
      	this.setBackground();
	  }
	},
    mounted () {
		this.$nextTick(() => {
          this.setBackground();
		})
    },
    methods: {
		setBackground() {
		  const bpName = this.$breakpoint.name;
		  switch (bpName) {
		    case "lg":
		  	case "xl":
		        this.bgImg = this.imgLarge;
		        break;
			case "md":
			  this.bgImg = this.imgMedium;
			  break;
		    case "sm":
		  	case "xs":
				this.bgImg = this.imgSmall;
				break;
			default:
              this.bgImg = false;
		  }
		  if (this.bgImg) {
            this.$el.querySelector('.hero__content').style.backgroundImage = `url('${this.bgImg}')`;
          } else {
            this.$el.querySelector('.hero__content').style.backgroundImage = "none";
		  }
		}
    },
}
</script>
